const borderTypes = ['solid', 'dotted', 'dashed', 'double', 'solid', 'dotted', 'dashed', 'double', 'solid', 'dotted', 'solid', 'dotted', 'dashed', 'double', 'solid', 'dotted', 'dashed', 'double', 'solid', 'dotted']
const borderColors = ['white', 'darkmagenta', 'orange', 'yellow', 'green', 'teal', 'purple', 'tan', 'pink', 'lightgreen', 'white', 'red', 'orange', 'yellow', 'green', 'teal', 'purple', 'tan', 'pink', 'lightgreen']

const getBorderCSS = (level) => {
  return { border: `${borderColors[level - 1]} ${borderTypes[level - 1]} 2px` }
}

export default getBorderCSS
